/* eslint-disable no-unused-vars */
import {
  SET_ALL_COURSES,
  SET_ONE_COURSE,
  SET_ONE_LESSON,
  SET_COURSES_OVERVIEW,
  UPDATE_COURSE,
} from '../types/elearning';
import { SET_ERRORS, CLEAR_ERRORS, LOADING_UI, SET_SUCCESS } from '../types/ui';
import {
  getCourses as getCoursesService,
  getCourse as getCourseService,
  getLesson as getLessonService,
  getCoursesOverview as getCoursesOverviewService,
  createCourse as createCourseService,
  createLesson as createLessonService,
  updateLesson as updateLessonService,
  uploadFile as uploadFileService,
  updateCourse as updateCourseService,
  deleteCourseService,
} from '../services/elearningService';

export const getAllCourses = () => async (dispatch) => {
  try {
    const courses = await getCoursesService();

    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_ALL_COURSES, payload: courses });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const uploadFile = (file) => async (dispatch) => {
  try {
    const fileUrl = await uploadFileService(file);

    dispatch({ type: CLEAR_ERRORS });
    return fileUrl;
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const getCoursesOverview = () => async (dispatch) => {
  try {
    const coursesOverview = await getCoursesOverviewService();

    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_COURSES_OVERVIEW, payload: coursesOverview });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const getCourse = (id) => async (dispatch) => {
  try {
    const courses = await getCourseService(id);

    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_ONE_COURSE, payload: courses });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const getLesson = (id) => async (dispatch) => {
  try {
    const courses = await getLessonService(id);

    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_ONE_LESSON, payload: courses });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const createCourse =
  (title, description, imageUrl) => async (dispatch) => {
    try {
      const courseId = await createCourseService(title, description, imageUrl);

      dispatch({ type: CLEAR_ERRORS });
      return courseId;
    } catch (error) {
      dispatch({
        type: SET_ERRORS,
        payload: error.response,
      });
    }
  };

export const createLesson =
  (courseId, title, description) => async (dispatch) => {
    try {
      const lessonId = await createLessonService(courseId, title, description);

      dispatch({ type: CLEAR_ERRORS });
      return lessonId;
    } catch (error) {
      dispatch({
        type: SET_ERRORS,
        payload: error.response,
      });
    }
  };

export const updateLesson = (lessonId, items) => async (dispatch) => {
  try {
    const updatedLesson = await updateLessonService(lessonId, items);

    return updatedLesson;
  } catch (error) {
    console.error(error);
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const updateCourse = (fields) => async (dispatch) => {
  try {
    await updateCourseService(fields);
  } catch (error) {
    console.error(error);
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const deleteCourse = (id) => async (dispatch) => {
  try {
    await deleteCourseService(id);
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};
